module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_show),
      expression: "choose_show"
    }],
    attrs: {
      "id": "show"
    }
  }, [_c('show')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_user),
      expression: "choose_user"
    }],
    attrs: {
      "id": "user"
    }
  }, [_c('user')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_project),
      expression: "choose_project"
    }],
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "project"
    }
  }, [_c('project')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_github),
      expression: "choose_github"
    }],
    attrs: {
      "id": "project"
    }
  }, [_c('github')], 1), _vm._v(" "), _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.ChooseUser(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/show.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("成果展示")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.ChooseUser(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/user.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("个人信息")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "show-dot": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.ChooseUser(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/project.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("项目")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "badge": "2"
    },
    on: {
      "on-item-click": function($event) {
        _vm.ChooseUser(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/github.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("个人项目")]), _vm._v(" "), _c('div', {
    slot: "default"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/github.png")
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-473a2f87!./~/.1.0.50@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/resume.vue
// module id = 96
// module chunks = 0